import i from './container-tracking-history.container';

export default i;
